import { Module } from "vuex";

import { GlobalLoadingState } from "@/interfaces/store/global-loading-state";
import { RootState } from "@/interfaces/store/root-state";

/**
 * 全画面モーダル・ストア
 */
export const globalLoadingModule: Module<GlobalLoadingState, RootState> = {
  namespaced: true,
  state: {
    opened: false,
    count: 0,
  },
  mutations: {
    show: (state: GlobalLoadingState): void => {
      state.opened = true;
      state.count = state.count + 1;
    },
    hide: (state: GlobalLoadingState): void => {
      state.opened = false;
      state.count = 0;
    },
    hideIfNoOthers: (state: GlobalLoadingState): void => {
      state.count = state.count - 1;

      if (state.count > 0) {
        return;
      }

      state.opened = false;
    },
  },
  getters: {},
  actions: {},
  modules: {},
};
